import React, { useEffect, useState } from "react";

const PROS = [
  ["CF", "Claire FONTAINE", "Opticienne-lunetière", "#2F80ED", "Responsable", "bor-resp"],
  ["MD", "Marc DEVEAUX", "Opticien-lunetier", "#7C4DFF", "Cotitulaire", "bor-coti"],
  ["LB", "Léa BONNET", "Monteuse-vendeuse", "#12A4A0", "Délégataire", "bor-dele"],
];

const MSGS = [
  {
    id: "m1",
    ini: "HM",
    col: "#2F80ED",
    from: "Dr Hélène MARCHAND",
    subj: "Compte rendu de consultation — Camille RIVIÈRE",
    meta: "helene.marchand@medecin.mssante.fr",
    hour: "09:12",
    out: false,
  },
  {
    id: "m2",
    ini: "CF",
    col: "#22A45D",
    from: "Claire FONTAINE",
    subj: "Information relative à une adaptation de prescription — Camille RIVIÈRE",
    meta: "à helene.marchand@medecin.mssante.fr · depuis la boîte de l'établissement",
    hour: "08:58",
    out: true,
  },
  {
    id: "m3",
    ini: "CH",
    col: "#F59E0B",
    from: "CH de Jargeau — Ophtalmologie",
    subj: "Courrier de sortie — M. T. MOREL",
    meta: "ophtalmo.jargeau@ch-jargeau.mssante.fr",
    hour: "08:47",
    out: false,
  },
  {
    id: "m4",
    ini: "OV",
    col: "#12A4A0",
    from: "Orthoptie du Val",
    subj: "Bilan orthoptique — Enfant L. MARTY",
    meta: "cabinet.duval@orthoptiste.mssante.fr",
    hour: "Hier",
    out: false,
  },
];

const STEPS = [
  {
    el: "bor-box",
    t: "Une seule adresse, celle du magasin",
    d: "Le correspondant écrit à l'établissement, pas à une personne. L'adresse ne change jamais, même si l'équipe change.",
  },
  {
    el: "bor-pros",
    t: "Les professionnels y sont rattachés",
    d: "Un responsable, des cotitulaires, des délégataires. Vous les déclarez, nous les rattachons — sans supplément.",
  },
  {
    el: "bor-list",
    t: "Tout le monde voit la même boîte",
    d: "Un seul flux, une seule organisation. Personne ne cherche « qui a reçu le courrier de l'ophtalmo ».",
  },
  {
    el: "m2",
    t: "Chaque envoi reste tracé",
    d: "Le message part de la boîte de l'établissement, et porte le nom du professionnel qui l'a envoyé.",
  },
];

export default function BoiteOrga() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const m = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    if (m && m.matches) return undefined;
    const id = setInterval(() => setI((v) => (v + 1) % STEPS.length), 3400);
    return () => clearInterval(id);
  }, []);

  const spot = (name) => (STEPS[i].el === name ? " bor-spot" : "");

  return (
    <div className="bor">
      <style>{BCSS}</style>

      <div className="bor-app">
        <aside className="bor-rail">
          <div className={"bor-box" + spot("bor-box")}>
            <div className="bor-lab">Boîte de l'établissement</div>
            <div className="bor-etab">Optique Rivage</div>
            <div className="bor-addr">optique-rivage@opticiens.mssante.fr</div>
            <div className="bor-city">45150 Jargeau</div>
          </div>

          <div className={"bor-pros" + spot("bor-pros")}>
            <div className="bor-lab bor-labr">
              Professionnels rattachés <em>{PROS.length}</em>
            </div>
            {PROS.map(([ini, nom, role, col, tag, cls]) => (
              <div className="bor-pro" key={ini}>
                <b style={{ background: col }}>{ini}</b>
                <span className="bor-id">
                  <span className="bor-nm">{nom}</span>
                  <span className="bor-ro">{role}</span>
                </span>
                <span className={"bor-pill " + cls}>{tag}</span>
              </div>
            ))}
          </div>
        </aside>

        <div className="bor-main">
          <div className="bor-top">
            <h3>Boîte de réception</h3>
            <span className="bor-secu">Messagerie sécurisée de santé</span>
          </div>

          <div className={"bor-list" + spot("bor-list")}>
            {MSGS.map((m) => (
              <div
                className={"bor-msg" + (m.out ? " bor-out" : "") + spot(m.id)}
                key={m.id}
              >
                <span className="bor-ic" style={{ background: m.col }}>
                  {m.ini}
                </span>
                <span className="bor-bd">
                  <span className="bor-fr">
                    {m.out ? <span className="bor-tag">Envoyé</span> : null}
                    {m.from}
                  </span>
                  <span className="bor-su">{m.subj}</span>
                  <span className="bor-me">{m.meta}</span>
                </span>
                <span className="bor-hr">{m.hour}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bor-dots">
        {STEPS.map((s, n) => (
          <button
            key={s.t}
            type="button"
            aria-label={s.t}
            className={"bor-dot" + (n === i ? " bor-doton" : "")}
            onClick={() => setI(n)}
          />
        ))}
      </div>

      <ol className="bor-caps">
        {STEPS.map((s, n) => (
          <li className={"bor-cap" + (n === i ? " bor-capon" : "")} key={s.t}>
            <b>{s.t}</b>
            <p>{s.d}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}

const BCSS = `
.bor{margin-top:30px}
.bor *{box-sizing:border-box}
.bor-app{background:#fff;border:1px solid #D8DCE2;border-radius:16px;overflow:hidden;
  box-shadow:0 26px 60px -34px rgba(15,23,42,.45);max-width:900px;margin:0 auto;display:flex}
.bor-rail{width:280px;flex:0 0 280px;border-right:1px solid #E6E8EC;background:#FAFBFC;
  padding:16px 15px;display:flex;flex-direction:column;gap:14px}
.bor-box,.bor-pros{border:1px solid #E6E8EC;border-radius:11px;background:#fff;padding:12px 13px;
  transition:box-shadow .2s,border-color .2s}
.bor-lab{font-size:9.6px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#8A93A5}
.bor-labr{display:flex;justify-content:space-between;align-items:center}
.bor-labr em{font-style:normal;color:#0080FF}
.bor-etab{font-size:14px;font-weight:600;margin-top:5px;color:#0F172A}
.bor-addr{font-size:12.4px;color:#0080FF;font-weight:600;margin-top:4px;word-break:break-all}
.bor-city{font-size:11.4px;color:#8A93A5;margin-top:3px}
.bor-pro{display:grid;grid-template-columns:28px 1fr;gap:4px 9px;padding:10px 0;
  border-bottom:1px solid #F1F3F6}
.bor-pro:last-child{border-bottom:0;padding-bottom:0}
.bor-pro b{grid-row:1 / span 2;width:28px;height:28px;border-radius:999px;color:#fff;font-size:11px;
  font-weight:700;display:grid;place-items:center;align-self:start}
.bor-id{min-width:0}
.bor-nm{display:block;font-size:12.6px;font-weight:600;line-height:1.25;color:#0F172A}
.bor-ro{display:block;font-size:10.6px;color:#8A93A5;margin-top:1px}
.bor-pill{justify-self:start;font-size:9.4px;font-weight:700;letter-spacing:.04em;
  text-transform:uppercase;border-radius:999px;padding:3px 9px;white-space:nowrap}
.bor-resp{background:#E3F0FF;color:#12406E;border:1px solid #B9D9FB}
.bor-coti{background:#EFE7FE;color:#3B2477;border:1px solid #D5C6F7}
.bor-dele{background:#EFF1F5;color:#334155;border:1px solid #DDE1E8}

.bor-main{flex:1;min-width:0;display:flex;flex-direction:column}
.bor-top{display:flex;align-items:center;gap:10px;padding:14px 18px 12px;border-bottom:1px solid #E6E8EC}
.bor .bor-top h3{font-size:15px;margin:0;color:#0F172A;font-weight:600}
.bor-secu{margin-left:auto;font-size:10.8px;font-weight:600;color:#14532D;background:#E8F7EE;
  border:1px solid #A8DCBE;border-radius:999px;padding:4px 10px}
.bor-list{padding:8px;display:grid;gap:6px;border:1px solid transparent;border-radius:12px;
  transition:box-shadow .2s,border-color .2s}
.bor-msg{display:grid;grid-template-columns:34px 1fr auto;gap:10px;align-items:start;
  padding:10px 11px;border:1px solid transparent;border-radius:10px;
  transition:background .2s,border-color .2s,box-shadow .2s}
.bor-ic{width:34px;height:34px;border-radius:999px;display:grid;place-items:center;font-size:11px;
  font-weight:700;color:#fff}
.bor-bd{min-width:0}
.bor-fr{display:block;font-size:12.4px;font-weight:600;color:#0F172A}
.bor-su{display:block;font-size:12.6px;color:#3B455C;margin-top:2px;line-height:1.35}
.bor-me{display:block;font-size:10.8px;color:#8A93A5;margin-top:3px}
.bor-hr{font-size:11px;color:#8A93A5;white-space:nowrap}
.bor-out{background:#F7FAFF}
.bor-tag{display:inline-block;font-size:9.4px;font-weight:700;letter-spacing:.04em;
  text-transform:uppercase;background:#E3F0FF;color:#12406E;border:1px solid #B9D9FB;
  border-radius:999px;padding:2px 7px;margin-right:6px;vertical-align:1px}

.bor-spot{border-color:#0080FF!important;box-shadow:0 0 0 4px rgba(0,128,255,.15)}
.bor-msg.bor-spot{background:#EAF4FF}

.bor-dots{display:flex;gap:7px;justify-content:center;margin-top:18px}
.bor-dot{width:8px;height:8px;padding:0;border:0;border-radius:999px;background:#CBD2DD;
  cursor:pointer;transition:background .2s,width .2s}
.bor-doton{width:22px;background:#0080FF}

.bor-caps{list-style:none;margin:26px 0 0;padding:0;display:grid;
  grid-template-columns:repeat(4,1fr);gap:12px}
.bor-cap{border:1px solid transparent;border-radius:12px;padding:14px 16px;
  transition:background .18s,border-color .18s}
.bor-cap b{display:block;font-size:14.2px;color:#8A93A5;transition:color .18s}
.bor .bor-cap p{font-size:13px;line-height:1.55;color:#98A1B2;margin:5px 0 0;transition:color .18s}
.bor-capon{background:#fff;border-color:#E6E8EC;box-shadow:0 10px 26px -22px rgba(15,23,42,.5)}
.bor-capon b{color:#0F172A}
.bor .bor-capon p{color:#5A6478}

@media (max-width:980px){
  .bor-app{flex-direction:column}
  .bor-rail{width:auto;flex:none;border-right:0;border-bottom:1px solid #E6E8EC;flex-direction:row}
  .bor-rail>*{flex:1}
  .bor-caps{grid-template-columns:repeat(2,1fr)}
}
@media (max-width:640px){
  .bor-rail{flex-direction:column}
  .bor-caps{grid-template-columns:1fr}
}
`;
